import { render, staticRenderFns } from "./FormTransaction.vue?vue&type=template&id=391343a5"
import script from "./FormTransaction.vue?vue&type=script&lang=js"
export * from "./FormTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports